export default __webpack_public_path__ + "static/media/icon-electric-car.987a1795.svg";